var React = require("react");
import Footer from "../general/Footer";
import Header from "../general/Header";
// import config from "./config/config";
import axios from "axios";
import ReactDOM from "react-dom";
import HeaderLoginSection from "../general/headerLoginSection";
import SavedImagesSection from "./SavedImagesSection";
import SearchImages from "./SearchImages";

import ImagePageApp from "./ImagePage";
import RealEventsImages from "./RealEventsImages";
if (typeof window === "undefined") {
  global.window = {};
}
class RealEventsProductApp extends React.Component {
  constructor(props) {
    props, "props Product";
    super(props);
    this.state = {
      otherProps: {
        cityList: [],
        areaList: [],
        occasionList: [],
      },
      newcitySession: null,
      sessionData: null,
      cityList: this.props.cityList,
      areaList: this.props.areaList,
      occasionList: this.props.occasionList,
      selected: this.props.selected,

      loadingData: false,
      data: this.props.data,
      tagsData: [],
      loadingTags: false,
      likeId: "",
      similarEvents: []
    };
    this.getAnalytics();
    // this.getAlbumData = this.getAlbumData.bind(this);
    this.searchImagesTags = this.searchImagesTags.bind(this);
  }
  toggleTab(index) {
    this.setState({ selected: index });
  }
  componentDidMount() {
    let oca = this.props.data?.detail?.occasion;
    this.getCookies();
    // this.getAlbumData();
    // this.searchImagesTags();
    setTimeout(() => {
      this.getSimilarEvents(oca);
    }, 3000)
  }
  getCookies = () => {
    const cookies = document.cookie.split(";").map((cookie) => cookie.trim());
    const sessionDataCookie = cookies.find((cookie) =>
      cookie.startsWith("sessionData=")
    );
    const userDataCookie = cookies.find((cookie) =>
      cookie.startsWith("userData=")
    );
    if (sessionDataCookie) {
      const sessionData = decodeURIComponent(sessionDataCookie.split("=")[1]);
      const parsedSessionData = JSON.parse(sessionData);
      if (parsedSessionData.sessionData !== undefined) {
        parsedSessionData.sessionData.user_profile_id =
          parsedSessionData.user_profile_id;
      }
      this.setState({ sessionData: parsedSessionData.sessionData });
      this.setState({ user_profile_id: parsedSessionData.user_profile_id });
    }
    if (userDataCookie) {
      const userData = decodeURIComponent(userDataCookie.split("=")[1]);
      const parsedUserData = JSON.parse(userData);

      this.setState({ userData: parsedUserData });
      this.setState({ eventId: parsedUserData.eventId });
    }
  };
  getAnalytics() {
    if (typeof window !== "undefined" && window.localStorage) {
      var pageType = "realEvents";
      localStorage.setItem("pageType", pageType);

      (function (i, s, o, g, r, a, m) {
        i["GoogleAnalyticsObject"] = r;
        (i[r] =
          i[r] ||
          function () {
            (i[r].q = i[r].q || []).push(arguments);
          }),
          (i[r].l = 1 * new Date());
        (a = s.createElement(o)), (m = s.getElementsByTagName(o)[0]);
        a.async = 1;
        a.src = g;
        m.parentNode.insertBefore(a, m);
      })(
        window,
        document,
        "script",
        "//www.google-analytics.com/analytics.js",
        "ga"
      );

      ga("create", "UA-39073605-1", {
        siteSpeedSampleRate: 30,
      });
      ga("send", "pageview");
    }
  }
  // getAlbumData() {
  //   let productName = this.props.pageType;
  //   let url = `https://api.bookeventz.com/RealEvent/getProductDetails?uniqueLink=${productName}`;
  //   try {
  //     axios.get(url).then((res) => {
  //       let dataa = res.data;
  //       this.setState({ data: res.data });
  //       if (dataa && dataa?.detail?.occasion) {
  //         let oca = dataa?.detail?.occasion;
  //         this.getSimilarEvents(oca);
  //       }
  //     });
  //   } catch (err) {
  //     console.log(err, "error");
  //   }
  // }
  searchImagesTags(input) {
    this.setState({ loadingTags: true });
    let url = `https://api.bookeventz.com/imageTags/searchImageTags?search=${input}&if_active=1`;
    try {
      axios.get(url).then((res) => {
        this.setState({ tagsData: res.data.data });
        this.setState({ loadingTags: false });
      });
    } catch (err) {
      console.log(err, "error");
    }
  }
  getSimilarEvents = (ocassion) => {
    let url = `https://api.bookeventz.com/album/getAlbumsListingDetails?occasionId=${ocassion}&ifActive=1&orderBy=sequence&limit=10`;
    try {
      axios.get(url).then((res) => {
        this.setState({ similarEvents: res.data?.data });
      });
    } catch (err) {
      console.log(err, "error");
    }
  };
  // submitHandleLike = (albumId) => {
  //   let likeUrl = `https://api.bookeventz.com/ImageTags/insertAlbumImage`;
  //   let likeData = {
  //     // authToken: "",
  //     // type: 1,
  //     // albumRelatedId: albumId,
  //     // ifLike: 1,
  //     // bypass: 404,
  //     // userName: this.props.sessionData?.userName,
  //     // userMobileNo: this.props.sessionData?.userMobileNo,
  //     // userEmail: this.props.sessionData?.userEmail,
  //     // userType: this.props.sessionData?.user_type,
  //     // userName: "Sahil katoch",
  //     // userMobileNo: 99999999,
  //     // userEmail: "sahil@testingmail.com",
  //     // userType: 1,
  //     // userReleatedId: "",
  //     album_id: albumId,
  //     image_attachment_id: 1,
  //     if_active: 1,
  //   };
  //   axios.post(likeUrl, querystring.stringify(likeData)).then((likeUpdate) => {
  //     console.log(likeUpdate.data.likeId, "likeId");
  //     this.setState({likeId: likeUpdate.data.likeId});
  //   });
  //   (error) => {
  //     console.log(error);
  //   };
  // };
  loginPopup = (isShowLoginModal) => {
    var url = window.location.href;
    var that = this;
    // history.pushState(null, null, url);
    let pathname = new URL(url).pathname;
    let pathArray = pathname.split("/");
    var city = pathArray[2];
    var props = {
      config: this.props.config,
      constants: this.props.constants,
      sessionData: this.props.sessionData,
      occasionList: this.props.occasionList,
      areaList: this.props.areaList,
      citySelected: { city },
      cityList: this.props.cityList,
      pageType: "realEventProduct",
      filters: this.props.filters,
      data: isShowLoginModal,
      isShowLoginModal:
        isShowLoginModal.isShowLoginModal != undefined
          ? isShowLoginModal.isShowLoginModal
          : isShowLoginModal,
      callType: "login",
      reviewLogin: isShowLoginModal.reviewLogin,
    };
    // ReactDOM.unmountComponentAtNode(document.getElementById("login"));
    ReactDOM.render(
      React.createElement(HeaderLoginSection, props),
      document.getElementById("login")
    );
  };
  handleLikeImage = () => {
    if (
      this.state.sessionData?.userName !== "" ||
      this.state.sessionData?.userName !== undefined ||
      this.state.sessionData?.userName !== null
    ) {
      submitHandleLike(albumId);
    } else {
      loginPopup(true);
    }
  };
  handleScrollTop = () => {
    let element = $("#header");
    let offsetAboutTop = element.offset();
    let aboutScreen = offsetAboutTop.top - 0;
    window.scrollTo({
      top: aboutScreen,
      behavior: "auto",
    });
  };
  render() {
    let data = this.state.data;
    var likeId = this.state.likeId;
    return (
      <div id="header">
        {this.props.pageType !== "image-page" && (
          <Header
            props={this.props}
            otherProps={this.state}
            newcitySession={this.state.sessionData}
            sessionData={this.state.sessionData}
            areaList={this.props.areaList}
            pageType={this.props.pageType}
            cityList={this.props.cityList}
          />
        )}
        {this.props.pageType !== "search" &&
          this.props.pageType !== "saved-albums" &&
          this.props.pageType !== "image-page" && (
            <RealEventsImages
              data={data}
              sessionData={this.state.sessionData}
              submitHandleLike={this.submitHandleLike}
              loginPopup={this.loginPopup}
              handleLikeImage={this.handleLikeImage}
              likeId={likeId}
              pageType={this.props.pageType}
              searchImagesTags={this.searchImagesTags}
              tagsData={this.state.tagsData}
              loadingTags={this.state.loadingTags}
              searchQueryText={this.props.searchQueryText}
              searchImageText={this.props.searchImageText}
              handleScrollTop={this.handleScrollTop}
              similarEvents={this.state.similarEvents}
            />
          )}
        {this.props.pageType == "search" && (
          <SearchImages
            searchImagesTags={this.searchImagesTags}
            tagsData={this.state.tagsData}
            data={data}
            pageType={this.props.pageType}
            loginPopup={this.loginPopup}
            sessionData={this.state.sessionData}
            searchQueryText={this.props.searchQueryText}
            loadingTags={this.state.loadingTags}
            searchImageText={this.props.searchImageText}
            handleScrollTop={this.handleScrollTop}
          />
        )}
        {this.props.pageType == "saved-albums" && (
          <SavedImagesSection
            loginPopup={this.loginPopup}
            sessionData={this.state.sessionData}
            pageType={this.props.pageType}
            searchImageText={this.props.searchImageText}
          />
        )}
        {this.props.pageType == "image-page" && (
          <ImagePageApp searchImageText={this.props.searchImageText} newImageInput={this.props.newImageInput} />
        )}
        {this.props.pageType !== "image-page" && (
          <Footer
            props={this.props}
            otherProps={this.state}
            newcitySession={this.state.sessionData}
            userData={this.props.userData}
            sessionData={this.state.sessionData}
            cityList={this.props.cityList}
            occasionList={this.props.occasionList}
            areaList={this.props.areaList}
            pageType={this.props.pageType}
          />
        )}
      </div>
    );
  }
}
export default RealEventsProductApp;
